import "./Tooltip.scss";

import React from "react";
import { Tooltip } from "@progress/kendo-react-tooltip";
import PropTypes from "prop-types";

/**
 * Tooltip component
 * @module
 * @param {string} anchorElement - Sets the anchor element of the Tooltip
 * @param {string} className - Sets a class of the Tooltip animation container
 * @param {function} content - Sets the content of the Tooltip
 * @param {function} filter - Represents a callback function which determines if a Tooltip will be displayed
 * @param {number} openDelay - Sets a delay in milliseconds
 * @param {string} parentTitle - If any of the parent elements has a title, displays a Tooltip
 * @param {string} position - Sets the position of the Tooltip
 * @param {func} onPosition - Callback function to determine the position of the Tooltip
 */
const TooltipComponent = (props) => {
  const {
    className,
    content,
    children,
    filter,
    openDelay,
    position,
    parentTitle,
    onPosition
  } = props;

  return (
    <Tooltip
      anchorElement="target"
      className={className}
      content={content ? (props) => content(props) : null}
      filter={(element) => (filter ? filter(element) : true)}
      openDelay={openDelay || 0}
      position={position || "top"}
      parentTitle={parentTitle}
      onPosition={onPosition}
    >
      {children}
    </Tooltip>
  );
};

TooltipComponent.propTypes = {
  className: PropTypes.string,
  content: PropTypes.func,
  filter: PropTypes.func,
  openDelay: PropTypes.number,
  parentTitle: PropTypes.bool,
  position: PropTypes.string,
  onPosition: PropTypes.func
};

export default TooltipComponent;
